import { apiClient } from './axios';

export interface PaymentLink {
  id: string;
  call_id: string | null;
  contact_id: string | null;
  campaign_id: string | null;
  natwest_link_id: string | null;
  natwest_order_id: string | null;
  payment_link_url: string;
  amount: string;
  currency: string;
  vehicle_name: string | null;
  vehicle_id: string | null;
  vehicle_registration: string | null;
  phone_number: string | null;
  customer_name: string | null;
  status: 'CREATED' | 'SENT' | 'OPENED' | 'PAID' | 'EXPIRED' | 'FAILED' | 'CANCELLED';
  sms_sent: boolean;
  sms_sid: string | null;
  paid_at: string | null;
  webhook_payload: Record<string, unknown> | null;
  error_message: string | null;
  reservation_status: string | null;
  reservation_id: string | null;
  reservation_error: string | null;
  reservation_payload: Record<string, unknown> | null;
  reservation_response: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
  call?: {
    id: string;
    phone_number: string | null;
    lead_data: Record<string, unknown> | null;
    executed_at: string;
  };
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

interface PaymentLinksQuery {
  status?: string;
  page?: number;
  limit?: number;
}

export const paymentsApi = {
  getPaymentLinks: async (query?: PaymentLinksQuery): Promise<PaginatedResponse<PaymentLink>> => {
    const response = await apiClient.get<PaginatedResponse<PaymentLink>>('/payments', {
      params: query,
    });
    return response.data;
  },

  getPaymentLinksByCall: async (callId: string): Promise<PaymentLink[]> => {
    const response = await apiClient.get<PaymentLink[]>(`/payments/by-call/${callId}`);
    return response.data;
  },

  updateStatus: async (id: string, status: string): Promise<PaymentLink> => {
    const response = await apiClient.patch<PaymentLink>(`/payments/${id}/status`, { status });
    return response.data;
  },

  retryReservation: async (id: string): Promise<RetryReservationResult> => {
    const response = await apiClient.post<RetryReservationResult>(
      `/crm-integration/reservations/${id}/retry`,
    );
    return response.data;
  },
};

export interface RetryReservationResult {
  reservation_status: string | null;
  reservation_error: string | null;
  reservation_id: string | null;
  reservation_payload: Record<string, unknown> | null;
  reservation_response: Record<string, unknown> | null;
}
